import { Body2 } from '@cian/ui-kit/typography';
import { Fragment } from 'react';

import type { IDetailsProp } from 'shared/utils/buildingDetails';

import style from './style.css';

export interface IBuildingDetailsProps {
  props: IDetailsProp[];
}

/** Детальные характеристики правой колонки: название над значением, название жирным, как `prop-list_misc` монолита */
export const BuildingDetails = ({ props }: IBuildingDetailsProps) => {
  if (!props.length) {
    return null;
  }

  return (
    <dl className={style['container']} data-name="BuildingDetails">
      {props.map(({ name, lines, note, isFeatureList }) => (
        <div key={name} className={style['prop']}>
          <dt>
            <Body2 fontWeight="bold">{name}</Body2>
          </dt>
          <dd className={style['value']}>
            {isFeatureList ? (
              <ul className={style['features']}>
                {lines.map(line => (
                  <li key={line} className={style['feature']}>
                    <Body2>{line}</Body2>
                  </li>
                ))}
              </ul>
            ) : (
              lines.map((line, index) => (
                <Body2 key={index} as="p">
                  {line}
                </Body2>
              ))
            )}
            {note && (
              <Body2 as="p" color="text-secondary-default" data-name="BuildingDetailsNote">
                {note.split('\n').map((noteLine, index) => (
                  <Fragment key={index}>
                    {index > 0 && <br />}
                    {noteLine}
                  </Fragment>
                ))}
              </Body2>
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
};
